import React from 'react';
import Layout from './src/components/Layout';

export const wrapPageElement = ({ element, props }) => {
  return (
      <Layout
          className={`page ${decodeURI(props.path.replaceAll('/', ''))}`}
          {...props}>
        {element}
      </Layout>
  );
};

export function shouldUpdateScroll(prevRouterProps, { location }) {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  const body = document.getElementsByTagName('body')[0]
  body.scrollTop = 0
  return false
}

export const onRouteUpdate = ({ location }) => {

    const isLernplattformSubpage = /^\/lernplattform\/.+/.test(location.pathname);

    if(!isLernplattformSubpage) {
        if (!document.querySelector('link[href="/chatbot/chatbot_styles.css"]')) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "/chatbot/chatbot_styles.css";
            link.id = "chatbot-css";
            document.head.appendChild(link);
        }

        if (!document.getElementById("chatbot-talk-bubble")) {
            const div = document.createElement("div");
            div.className = "chatbot-talk-bubble chatbot-tri-right chatbot-btm-right";
            div.id = "chatbot-talk-bubble";
            div.style.display = "none";
            div.innerHTML = `
                <div class="chatbot-talktext">
                    <span class="chatbot-talktexth3"><b>WIE SEHR HAST DU DEINE NEURODERMITIS UNTER KONTROLLE</b></span>
                </div>
              `;
            document.body.appendChild(div);
        }

        if (!document.querySelector('script[src="/chatbot/chatbot_scripts.js"]')) {
            const script = document.createElement("script");
            script.src = "/chatbot/chatbot_scripts.js";
            script.type = "text/javascript";
            script.defer = true;
            document.body.appendChild(script);
        }
    }
}
